/**
 * Asynchronously loads the component for FeaturePage
 */
import { lazyLoad } from 'utils/loadable';

export default lazyLoad(
    () => import('./index'),
    module => module.default,
);
